import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { GalleriaModule } from 'primeng/galleria';
import { PropertiesService } from '../properties.service';
import { Subscription } from 'rxjs';
import { Property } from '../properties.model';
import { MenuItem } from 'primeng/api';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { BreadcrumbComponent } from '@shared/components/breadcrumb/breadcrumb.component';
import { NgProgressService } from '@shared/services/ng-progress.service';
import { SafeUrl } from '@angular/platform-browser';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-photos-gallery',
  imports: [
    CommonModule,
    GalleriaModule,
    ButtonModule,
    AngularSvgIconModule,
    BreadcrumbComponent,
    SkeletonModule,
  ],
  templateUrl: './photos-gallery.component.html',
})
export class PhotosGalleryComponent implements OnInit, OnDestroy {
  @ViewChild(GalleriaModule) galleria!: GalleriaModule;

  displayBasic: boolean = false;
  selectedImageIndex: number = 0;
  images: (string | SafeUrl)[] = [];
  groupedImages: (string | SafeUrl)[][] = [];

  property: Property | null = null;
  breadcrumdItems: MenuItem[] = [];

  private propertySub = Subscription.EMPTY;

  readonly _propertiesService = inject(PropertiesService);
  private readonly _activatedRoute = inject(ActivatedRoute);
  private readonly _ngProgressService = inject(NgProgressService);

  ngOnInit() {
    this._ngProgressService.startLoader();
    window.addEventListener('keydown', this.onKeyDown);

    const id = this._activatedRoute.snapshot.paramMap.get('id');

    this.propertySub = this._propertiesService.property$.subscribe(
      (property) => {
        if (!property) {
          return;
        }

        this.setupBreadcrumb(property?.name || '', property!.$id);
        property.isBookmarked = this._propertiesService.isPropertyBookmarked(
          property.$id
        );
        this.property = property;
        this.parseImages();
        console.log(this.property?.images);
        this._ngProgressService.completeLoader();
      }
    );

    this._propertiesService.getProperty(id!);
  }

  onPropertyBookmark(): void {
    this.property!.isBookmarked = !this.property?.isBookmarked;
    this._propertiesService.bookmarkProperty(
      this.property!.$id,
      this.property!.isBookmarked
    );
  }

  onShowGallery(imageIndex: number): void {
    this.selectedImageIndex = imageIndex;
    this.displayBasic = true;

    console.log(this.selectedImageIndex);
  }

  private parseImages(): void {
    this.images = this.property?.images.map((image) => image.url) || [];

    this.groupedImages = this.imageGroups(this.images);
  }

  private imageGroups(images: (string | SafeUrl)[]): (string | SafeUrl)[][] {
    const result: (string | SafeUrl)[][] = [];
    for (let i = 0; i < images.length; i += 3) {
      result.push(images.slice(i, i + 3));
    }
    return result;
  }

  private setupBreadcrumb(propertyName: string, propertyId: string): void {
    this.breadcrumdItems = [
      {
        label: 'Properties',
        routerLink: '/home/properties',
      },
      {
        label: propertyName || 'Property Details',
        routerLink: `/home/properties/view/${propertyId}`,
      },
      {
        label: 'Photos',
      },
    ];
  }

  private onKeyDown = (event: KeyboardEvent): void => {
    if (!this.displayBasic) return; // Only react if gallery is open

    if (event.key === 'ArrowRight') {
      this.selectedImageIndex =
        (this.selectedImageIndex + 1) % this.images.length;
    }

    if (event.key === 'ArrowLeft') {
      this.selectedImageIndex =
        (this.selectedImageIndex - 1 + this.images.length) % this.images.length;
    }
  };

  ngOnDestroy(): void {
    this.propertySub.unsubscribe();
    window.removeEventListener('keydown', this.onKeyDown);
  }
}
